import React from "react";

import "./styles.css";

const Render = props => {
  return (
    <div>
      <div
        className="popup dialogoSalir borderBox"
        role="alertdialog"
        aria-labelledby="salir"
      >
        <div role="document">
          <button
            type="button"
            className="closePop pAbs hoverGrow indentedText"
            onClick={props.onClose}
          >
            Cerrar
          </button>
          <h2 id="salir" className="avenirBK violet alignCenter">
            ¿Estás seguro que deseás salir?
          </h2>
          <p className="violet alignCenter">
            Si abandonás, tendrás que empezar desde el comienzo.
          </p>

          <ul className="btnUl unstyled pvl">
            <li className="mha">
              <button
                type="button"
                className="btn mha"
                onClick={props.onAccept}
              >
                Aceptar
              </button>
            </li>
            <li className="mha">
              <button
                type="button"
                className="btn btnEmpty mha"
                onClick={props.onClose}
              >
                Cancelar
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="modalBG" />
    </div>
  );
};

export default Render;



// WEBPACK FOOTER //
// ./src/components/DialogSalir/Render.js